export const IMAGE2_REVISION_INSTRUCTION_MIN_LENGTH = 7;
export const IMAGE2_REVISION_INSTRUCTION_MAX_LENGTH = 1_000;

export function image2RevisionInstructionLength(value: string): number {
  return Array.from(value.trim()).length;
}

export function image2RevisionInstructionValid(value: string): boolean {
  const length = image2RevisionInstructionLength(value);
  return length >= IMAGE2_REVISION_INSTRUCTION_MIN_LENGTH
    && length <= IMAGE2_REVISION_INSTRUCTION_MAX_LENGTH;
}

export function limitImage2RevisionInstruction(value: string): string {
  return Array.from(value).slice(0, IMAGE2_REVISION_INSTRUCTION_MAX_LENGTH).join("");
}
